export default "__VITE_ASSET__gHh2uHgV__"